"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CT_SQG_ACCUMULATION_THRESHOLD_KG = exports.MN_ACCUMULATION_THRESHOLD_ACUTE_KG = exports.MN_VSQG_ACCUMULATION_THRESHOLD_KG = exports.MN_SQG_ACCUMULATION_THRESHOLD_KG = exports.SQG_ACCUMULATION_THRESHOLD_KG = exports.VSQG_ACCUMULATION_THRESHOLD_ACUTE_KG = exports.VSQG_ACCUMULATION_THRESHOLD_KG = exports.TEXAS_CLASS_1_ONLY_LB = exports.KSQG_THRESHOLD_HAZARDOUS_LB = exports.LQG_THRESHOLD_HAZARDOUS_LB = exports.LQG_THRESHOLD_HAZARDOUS_KG = exports.SQG_THRESHOLD_HAZARDOUS_LB = exports.SQG_THRESHOLD_HAZARDOUS_KG = exports.VSQG_THRESHOLD_HAZARDOUS_LB = exports.VSQG_THRESHOLD_HAZARDOUS_KG = exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_LB = exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_KG = void 0;
// Federal Generator Status Thresholds
exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_KG = 1;
exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_LB = 2.2;
exports.VSQG_THRESHOLD_HAZARDOUS_KG = 0;
exports.VSQG_THRESHOLD_HAZARDOUS_LB = 0;
exports.SQG_THRESHOLD_HAZARDOUS_KG = 100;
exports.SQG_THRESHOLD_HAZARDOUS_LB = 220;
exports.LQG_THRESHOLD_HAZARDOUS_KG = 1000;
exports.LQG_THRESHOLD_HAZARDOUS_LB = 2200;
// Kansas Small Quantity Generator
exports.KSQG_THRESHOLD_HAZARDOUS_LB = 55;
// Texas Class 1 Only Threshold
exports.TEXAS_CLASS_1_ONLY_LB = 220;
// (40 CFR 262.14/262.16)
// max on-site at any time (distinct from monthly generation)
exports.VSQG_ACCUMULATION_THRESHOLD_KG = 1000;
exports.VSQG_ACCUMULATION_THRESHOLD_ACUTE_KG = 1;
exports.SQG_ACCUMULATION_THRESHOLD_KG = 6000;
// (Minn. R. 7045.0292)
// max on-site at any time (distinct from monthly generation)
exports.MN_SQG_ACCUMULATION_THRESHOLD_KG = 3000;
exports.MN_VSQG_ACCUMULATION_THRESHOLD_KG = 1000;
exports.MN_ACCUMULATION_THRESHOLD_ACUTE_KG = 1;
// (RCSA § 22a-449(c)-102, modifying 40 CFR 262.34(d) as of July 1, 2000)
// max on-site at any time (distinct from monthly generation)
exports.CT_SQG_ACCUMULATION_THRESHOLD_KG = 1000;
//# sourceMappingURL=wasteGeneratorStatusThresholds.js.map